'use client';

import Link from 'next/link';
import Image from 'next/image';
import { Button } from '../ui/Button';
import { ArrowRight } from 'lucide-react';
import { useTranslations } from 'next-intl';

export function Hero() {
  const t = useTranslations('hero');

  return (
    <section className="relative overflow-hidden bg-section-navy-light">
      <div className="absolute inset-0">
        <div
          className="absolute inset-0 bg-cover bg-center bg-no-repeat opacity-70 scale-105 animate-hero-zoom blur-[3px]"
          style={{ backgroundImage: "url('/images/background.png')" }}
        />
        <div className="absolute inset-0 bg-gradient-to-b from-dark-navy/100 via-dark-navy/50 to-pink-white/100" />
        <div className="absolute inset-0 bg-hero-radial" />
      </div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 z-10 py-24 md:py-28 lg:py-32">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          <div className="text-center lg:text-left">
            <h1 className="text-4xl sm:text-5xl lg:text-6xl xl:text-7xl font-bold leading-tight mb-8 text-primary-foreground">
              {t('title')}
            </h1>

            <div className="space-y-6 mb-8">
              <div>
                <h2 className="text-lg sm:text-xl text-primary-foreground font-semibold mb-2">
                  {t('titleSafetizen')}
                </h2>
                <p className="text-base sm:text-lg text-primary-foreground/90 leading-relaxed">
                  {t('descriptionSafetizen')}
                </p>
              </div>

              <div>
                <h2 className="text-lg sm:text-xl text-primary-foreground font-semibold mb-2">
                  {t('titleEarit')}
                </h2>
                <p className="text-base sm:text-lg text-primary-foreground/90 leading-relaxed">
                  {t('descriptionEarit')}
                </p>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row gap-3 justify-center lg:justify-start items-center">
              <Link href="/safetizen">
                <Button size="lg" className="group">
                  {t('ctaSafetizen')}
                  <ArrowRight className="ml-2 w-5 h-5 inline-block group-hover:translate-x-1 transition-transform" />
                </Button>
              </Link>
              <Link href="/earit">
                <Button size="lg" variant="secondary" className="group">
                  {t('ctaEarit')}
                  <ArrowRight className="ml-2 w-5 h-5 inline-block group-hover:translate-x-1 transition-transform" />
                </Button>
              </Link>
            </div>
          </div>

          <div className="flex justify-center lg:justify-end overflow-visible py-4">
            <Image
              src="/images/normal_light.png"
              alt="Safetizen — aperçu de l'application"
              width={522}
              height={1078}
              priority
              className="h-auto w-full max-w-[360px] sm:max-w-[440px] lg:max-w-[540px] drop-shadow-2xl rotate-[6deg]"
              sizes="(max-width: 640px) 360px, (max-width: 1024px) 440px, 540px"
            />
          </div>
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 h-28 bg-gradient-to-t from-pink-white to-transparent pointer-events-none" />
    </section>
  );
}
